(function() {
$(document).ready(function () {
  // Smooth scrolling
  $("nav.sticky-menu a").click(function (event) {
    event.preventDefault();
    const href = $(this).attr("href");
    const target = $(href);
    const yOffset = -70;
    const y = target.offset().top + yOffset;

    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000,
      "easeInOutExpo"
    );
  });

  // Highlight menu items on scroll
  const menuItems = $("nav.sticky-menu a");
  const sections = $("sectionxe");

  const observerOptions = {
    rootMargin: "-70px 0px -70% 0px",
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const index = Array.from(sections).indexOf(entry.target);
        menuItems.removeClass("current");
        menuItems.eq(index).addClass("current");
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  sections.each((_, section) => observer.observe(section));

  // Open modal
  $(".riiroo-apply-button").click(function (event) {
    event.preventDefault();
    $("#airtable-form").show();
  });

  // Close modal
  $(".close").click(function () {
    $("#airtable-form").hide();
  });

  $(window).click(function (event) {
    if (event.target.id === "airtable-form") {
      $("#airtable-form").hide();
    }
  });
});
})();